import { render, staticRenderFns } from "./DetailsTitle.vue?vue&type=template&id=4b69e810&"
import script from "./DetailsTitle.vue?vue&type=script&setup=true&lang=js&"
export * from "./DetailsTitle.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DetailsTitle.vue?vue&type=style&index=0&id=4b69e810&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports